export default `
上頭cut budget，叫阿信俾4個名去炒


UPDATE
阿信提議做個系統去評估員工表現，再決定係唔係要炒人。

好啦，咁睇下聽日個投票結果點，睇下邊個會俾人炒～
`;
